import * as actionTypes from '../actionTypes';
import * as spinnerActions from '../spinnerActions';
import {moduleTypes} from '../../util/constants';
import {getAccessToken} from '../authenticateActions'
import {getAxiosInstance} from '../../util/service';
import {store} from '../../store/configureStore';
import { getCompanyId } from '../../util/customMethods';

export const importRatePlan = (file,inputFileRef) => {
    const corporateId = store.getState().authInfo.userDetails.corporationId;
    const _url = `adhoc/importRatePlans/${getCompanyId()}/${corporateId}?access_token=${getAccessToken()}`;
    return async (dispatch) => {
        try {
            const formData = new FormData();
            formData.append("file", file); 
            const response = await getAxiosInstance(moduleTypes.ADMIN).post(_url, formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
                    }});
            if(response.status===200){
           return response.data;
        }else{
            return response.data;
        }
        } catch (error) {
            return error;
        }
    }
}

export const exportRatePlan = (selectedDate, accountType) => {
    const corporateId = store.getState().authInfo.userDetails.corporationId;
    const _url = `adhoc/exportRatePlans/${getCompanyId()}/${corporateId}?asOfDate=${selectedDate}&accType=${accountType}&accId=&access_token=${getAccessToken()}`;
    return async () => {
        try {
            const response = await getAxiosInstance(moduleTypes.ADMIN).get(_url, {
             responseType: 'blob' });
            if (response.status === 200) {
                const blob = new Blob([response.data], {
                type: 'application/vnd.ms-excel',
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ExportRatePlan.xls'); // 👈 desired file name
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
         }
        } catch (error) {
        
        }
    }
}